var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDoor = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.20924V16H14V7.20924C14 -2.40308 0 -2.40308 0 7.20924ZM10.9153 8.93453C10.2034 8.93453 9.64972 8.35944 9.64972 7.62003C9.64972 6.88062 10.2034 6.30552 10.9153 6.30552C11.6271 6.30552 12.1808 6.88062 12.1808 7.62003C12.1808 8.35944 11.6271 8.93453 10.9153 8.93453Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDoor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Door.2ce2d9d7.svg";
export { ForwardRef as ReactComponent };